import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { OverviewSection, PaymentsSection, BookingsSection, AdsSection, AnalyticsSection } from "@/components/admin/AdminSections";
import { ModerationSection, UsersSection } from "@/components/admin/AdminModeration";
import { NewsletterSection } from "@/components/admin/AdminNewsletter";
import { InvoicesSection, EventsSection } from "@/components/admin/AdminBilling";
import { SupportSection, SuggestionsSection } from "@/components/admin/AdminSupport";
import { ShieldCheck } from "lucide-react";

const TABS = [
  ["overview", "Dashboard", OverviewSection],
  ["users", "Utenti", UsersSection],
  ["payments", "Pagamenti", PaymentsSection],
  ["bookings", "Prenotazioni e Contratti", BookingsSection],
  ["ads", "ADV", AdsSection],
  ["moderation", "Moderazione", ModerationSection],
  ["analytics", "Analytics", AnalyticsSection],
  ["newsletter", "Newsletter", NewsletterSection],
  ["invoices", "Fatture", InvoicesSection],
  ["events", "Eventi", EventsSection],
  ["support", "Richieste di supporto", SupportSection],
  ["suggestions", "Suggerimenti", SuggestionsSection],
];

export default function Admin() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user || user.role !== "admin") {
    return <div className="max-w-3xl mx-auto px-6 py-16 text-center" data-testid="admin-denied"><p>Area riservata agli amministratori.</p><Link to="/" className="btn-pill-gold inline-flex mt-4">Torna alla home</Link></div>;
  }
  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="admin-panel">
      <span className="overline text-gold flex items-center gap-2"><ShieldCheck className="w-4 h-4"/>Pannello di controllo</span>
      <h1 className="font-display text-4xl sm:text-5xl font-bold mt-2 mb-8">Amministrazione</h1>
      <Tabs defaultValue="overview">
        <TabsList className="flex flex-wrap h-auto gap-1 bg-navy p-1.5 rounded-2xl justify-start">
          {TABS.map(([k, l]) => (
            <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`} className="rounded-xl text-white/80 data-[state=active]:bg-gold data-[state=active]:text-navy px-4 py-2">{l}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="mt-6"><C/></TabsContent>)}
      </Tabs>
    </div>
  );
}
